import { useMemo } from "react";
import { useEntryDataStore } from "./useDataEntryStore";

// orgId → "Parent Co. › Ingredients › Region › Branch" (ancestor names
// joined by ›, excluding the leaf node itself). Includes the parent_company
// root (depth 0) AND group dividers (isGroup nodes) so top-level
// subsidiaries get a non-empty breadcrumb like "Group › Ingredients › T Ltd".
export const useOrgPathById = () => {
  const { filteredOrgTree } = useEntryDataStore();
  return useMemo(() => {
    const map = new Map();
    const visit = (nodes, ancestors) => {
      for (const node of nodes || []) {
        if (node.isGroup) {
          visit(node.children, [...ancestors, node.name]);
          continue;
        }
        const key = node.id || node._id;
        if (key) map.set(String(key), ancestors.join(" › "));
        if (node.children?.length) {
          visit(node.children, [...ancestors, node.name]);
        }
      }
    };
    visit(filteredOrgTree, []);
    return map;
  }, [filteredOrgTree]);
};
